import { useQuery } from '@tanstack/react-query';
import { Appointment } from 'src/models';
import { api } from 'src/services';

export type UseGetAppointmentListParams = {
  patientId?: number;
  patientName?: string;
};

export type GetAppointmentListResponse = {
  Appointments: Appointment[];
  total: number;
  reminder_patient_appt_count: number;
  total_patient_appt_count: number;
};

export const useGetAppointmentList = ({
  patientId,
  patientName,
}: UseGetAppointmentListParams) => {
  return useQuery({
    queryKey: ['appointments', patientId],
    queryFn: () =>
      api
        .post<GetAppointmentListResponse>('/get_appointment/filters', {
          patient_id: patientId,
          patient_name: patientName,
        })
        .then(({ data }) => ({
          appointments: data.Appointments,
          total: data.total,
        })),
  });
};
